import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import "./i18n";
import App from "./App.tsx";
import { Toaster } from "@/components/ui/sonner";
import { initSentry } from "./lib/sentry";

initSentry();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div className="flex min-h-screen items-center justify-center text-red-700">
          <p>Une erreur est survenue. Veuillez rafraîchir la page.</p>
        </div>
      }
    >
      <App />
      <Toaster richColors theme="light" position="bottom-center" />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
